import axios from 'axios';

import buildPaginationQueryOpts from '@/shared/sort/sorts';

import { IUserStampsBalance } from '@/shared/model/user-stamps-balance.model';

const baseApiUrl = 'api/user-stamps-balances';
const baseSearchApiUrl = 'api/_search/user-stamps-balances?query=';

export default class UserStampsBalanceService {
  public search(query, paginationQuery): Promise<any> {
    return new Promise<any>(resolve => {
      axios.get(`${baseSearchApiUrl}${query}&${buildPaginationQueryOpts(paginationQuery)}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public find(id: number): Promise<IUserStampsBalance> {
    return new Promise<IUserStampsBalance>(resolve => {
      axios.get(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public retrieve(paginationQuery?: any): Promise<any> {
    return new Promise<any>(resolve => {
      axios.get(baseApiUrl + `?${buildPaginationQueryOpts(paginationQuery)}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>(resolve => {
      axios.delete(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public create(entity: IUserStampsBalance): Promise<IUserStampsBalance> {
    return new Promise<IUserStampsBalance>(resolve => {
      axios.post(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public update(entity: IUserStampsBalance): Promise<IUserStampsBalance> {
    return new Promise<IUserStampsBalance>(resolve => {
      axios.put(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }
}
